module.exports = __webpack_public_path__ + "static/media/ORDENANZA TRIBUTARIA 578-2022.c834419a.pdf";